import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input() public message  : string ='';
  @Input() public whiteMode: boolean=false;

  constructor() { }

  ngOnInit() {
  }
}
